import {
  CustomerAddress, CustomerArticlePrice,
  CustomerArticlesInDelivery,
  CustomerArticleStocks
} from '@iw-shop/customer/interfaces/customer';

export class Customer {
  customerNumber?: string;
  priceGroup?: string;
  status?: 'new' | 'changed' | 'unchanged';
  numberOfRepresentative?: string;
  priceMode?: 'gross' | 'net';
  CEO?: string;
  buyer?: string;
  customerSince?: string;
  classification?: string;
  defaultDeliveryPeriod?: string;
  creditLimit?: number;
  creditLimitAvailable?: number;
  creditLimitRating?: number;
  dateOfBirth?: string;
  visibilityGroups?: string[];
  favoritesList?: string[];
  articlesInDelivery?: CustomerArticlesInDelivery[];
  articleStocks?: CustomerArticleStocks[];
  paymentDeadlines?: {
    paymentDeadlineInDays: number,
    paymentFeeInPercent: number;
  }[];
  articlePrices?: CustomerArticlePrice[];
  dynamicArticleIds?: string[]

  constructor(
    public id: string,
    public email: string,
    public addresses: CustomerAddress[],
    public dateCreated?: Date,
    public lastUpdate?: Date,

    public guest: boolean = false

  ) {
  }
}
